import { useState } from "react";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { isEmailValid } from "../../utils/validations";
import { actualizarUsuario } from "../../api/usuarios";
import { useNavigate } from "react-router-dom";
import queryString from "query-string";
import { LogsInformativos } from "../logs/logs";

export default function ModificarUsuarios({ data, history, setShow }) {
    console.log(data);
    const idDocumental = data[0];

    const dataTemp = {
        nombre: data[1],
        email: data[2],
        password: data[3],
        tipo: data[4]
    };

    const [formData, setFormData] = useState(initialFormValue(dataTemp));
    const [signInLoading, setSignInLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();

        if (!formData.nombre || !formData.email || !formData.password1 || !formData.tipo) {
            toast.warning("Completa todos los campos del formulario.");
        } else {
            if (!isEmailValid(formData.email)) {
                toast.warning("Correo no valido");
            } else {
                if (formData.password1 !== formData.password2) {
                    toast.warning("Las contraseñas no coinciden");
                } else {
                    setSignInLoading(true);
                    try {
                        const dataTemp = {
                            nombre: formData.nombre,
                            email: formData.email,
                            password: formData.password1,
                            tipo: formData.tipo,
                            estado: "true"
                        };
                        actualizarUsuario(idDocumental, dataTemp).then((response) => {
                            const { data } = response;
                            console.log(data)

                            toast.success(data.mensaje);

                            history({
                                search: queryString.stringify(""),
                            });
                            LogsInformativos("Se ha modificado el usuario " + dataTemp.nombre, dataTemp)
                            setSignInLoading(false);
                            setShow(false);
                            //cancelarRegistro()
                        }).catch((ex) => {
                            if (ex.message === "Network Error") {
                                toast.error("Conexión al servidor no disponible");
                                setSignInLoading(false);
                            } else {
                                if (ex.response && ex.response.status === 401) {
                                    const { mensaje } = ex.response.data;
                                    toast.error(mensaje);
                                    setSignInLoading(false);
                                }
                            }
                        });
                    } catch (ex) {
                        toast.error("Error al iniciar sesión");
                        setSignInLoading(false);
                    }
                }
            }
        }
    };

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <div className="containerInicio">
            <Form onChange={onChange} onSubmit={onSubmit}>
                <Form.Group className="datosPersonalesReg">
                    <Form.Label>Nombre (s): </Form.Label>
                    <Form.Control
                        type="text"
                        className="nomNewUser"
                        placeholder="Nombre (s)"
                        name="nombre"
                        defaultValue={formData.nombre}
                    />
                </Form.Group>
                <Form.Group className="datosAcceso">
                    <Form.Label>Correo electrónico: </Form.Label>
                    <Form.Control
                        type="email"
                        className="emailNewUser"
                        placeholder="ejemplo@ejemplo.com"
                        name="email"
                        defaultValue={formData.email}
                    />
                    <Form.Label>Contraseña</Form.Label>
                    <Form.Control
                        type="password"
                        className="passNewUser"
                        placeholder="Ingrese una contraseña"
                        name="password1"
                        defaultValue={formData.password1}
                    />
                    <Form.Label>Confirmar contraseña</Form.Label>
                    <Form.Control
                        type="password"
                        className="passConfirmNewUser"
                        placeholder="Confirme contraseña"
                        name="password2"
                        defaultValue={formData.password2}
                    />
                    <Form.Label>Tipo</Form.Label>
                    <Form.Control
                        as="select"
                        className="passConfirmNewUser"
                        placeholder="Tipo"
                        name="tipo"
                        defaultValue={formData.tipo}
                    >
                        <option value="">Selecciona una opcion</option>
                        <option value="doctor" selected={formData.tipo == "doctor"}>Doctor</option>
                        <option value="mensajero" selected={formData.tipo == "mensajero"}>Mensajero</option>
                        <option value="administrador" selected={formData.tipo == "administrador"}>Administrador</option>
                        <option value="almacen" selected={formData.tipo == "almacen"}>Almacen</option>
                        <option value="finanzas" selected={formData.tipo == "finanzas"}>Finanzas</option>
                        <option value="rHumanos" selected={formData.tipo == "rHumanos"}>Recursos Humando</option>
                        <option value="cProduccion" selected={formData.tipo == "cProduccion"}>Coordinador de Producción</option>
                        <option value="contabilidad" selected={formData.tipo == "contabilidad"}>Contabilidad</option>
                        <option value="mesa de control" selected={formData.tipo == "mesa de control"}>Mesa de control</option>
                    </Form.Control>
                </Form.Group>
                <br />
                <label></label>
                <div className="divSubmit">
                    <input className="submit" value="Enviar" type="submit" />
                </div>
            </Form>
        </div>
    );
};

function initialFormValue(data) {
    return {
        nombre: data.nombre,
        email: data.email,
        password1: data.password,
        password2: "",
        tipo: data.tipo
    };
}
